import { MODULE_NAME as PARENT_MODULE_NAME } from '../../const';
export const MODULE_NAME = `${PARENT_MODULE_NAME}/generalConfigurationWidgetEditor`; // its not part of the main module stores, because it nested inside selectedWorkflow module
